<template>
  <div>
    <v-app>
      <v-main>
        <template v-if="!$route.meta.beforeLogin">
          <mobile-header />
          <side-nav />
        </template>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import SideNav from './components/common/SideNav.vue'
import MobileHeader from './components/common/MobileHeader.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
export default {
  name: 'App',
  components: { SideNav, MobileHeader },

  data: () => ({
    //
  }),
  computed: {
    bkPointName() {
      const bkPtName = this.$vuetify.breakpoint.name
      if (bkPtName === 'xs') {
        return true
      }
      return false
    }
  },
  created() {
    this.getAuth().then(() => {
      this.getLicensee()
    })
  },
  methods: {
    getLicensee() {
      this.$store.dispatch('licensees/getLicensee')
    },
    async getAuth() {
      return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(async(user) => {
          if (user) {
            resolve(user);
          } else {
            reject();
          }
        });
      })
    }
  }
}
</script>
